// extracted by mini-css-extract-plugin
export var body = "_e4-0";
export var sectionHeader = "_e4-4";
export var shortcutColumns = "_e4-2";
export var shortcutList = "_e4-1";
export var shortcutSection = "_e4-3";